import React from 'react';
import { theme } from 'twin.macro';
import { css } from '@emotion/react';
import { motion } from 'framer-motion';

import { KofiFrame } from './KofiFrame';
import CardMain from '../cards/CardMain';
import { useCardContext } from '../cards/CardContext';

export const TipWithKoFiCard: React.FC<{ onClickHeader?: (() => void) | undefined }> = () => {
  const { interaction } = useCardContext();

  if (!interaction?.details?.username) {
    return null;
  }

  return (
    <div
      css={[
        css`
          position: relative;
          background: #fff;
          border-radius: 1.5rem;
          overflow: hidden;
          border: 1px solid ${theme`colors.gray.19`};
          height: 512px;
        `,
      ]}
    >
      <motion.div
        style={{ opacity: 1 }}
        variants={{
          [`card.compress.${interaction.id}`]: { opacity: 0 },
          [`card.expand.all`]: { opacity: 1 },
        }}
      >
        <KofiFrame interaction={interaction} username={interaction.details.username} />
      </motion.div>
      <motion.div
        style={{ top: '-100%' }}
        variants={{
          [`card.compress.${interaction.id}`]: { top: '0%' },
          [`card.expand.all`]: { top: '-100%' },
        }}
        css={css`
          position: absolute;
          left: 0;
          right: 0;
        `}
      >
        <CardMain.StandardCard />
      </motion.div>
    </div>
  );
};
